import { shellCard } from '@/pages/dashboard/components/dashboardTheme'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

type DashboardSectionProps = {
	title: string
	subtitle?: string
	icon: string
	analyticsLink: string
	analyticsLabel?: string
	filter?: ReactNode
	children: ReactNode
	className?: string
}

export function DashboardSection({
	title,
	subtitle,
	icon,
	analyticsLink,
	analyticsLabel = 'View full analytics',
	filter,
	children,
	className = '',
}: DashboardSectionProps) {
	return (
		<section className={`${className}`}>
			<div className={`${shellCard} overflow-hidden`}>
				<div className="border-b border-border/70 bg-gradient-to-r from-primary/10 via-transparent to-transparent px-6 py-5">
					<div className="flex flex-wrap items-start justify-between gap-4">
						<div className="flex items-start gap-3">
							<div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/15 text-primary">
								<i className={`${icon} text-xl`} aria-hidden />
							</div>
							<div>
								<h2 className="font-display text-xl font-semibold tracking-tight text-foreground lg:text-[1.35rem]">{title}</h2>
								{subtitle ? <p className="mt-1 text-sm font-medium text-muted-foreground">{subtitle}</p> : null}
							</div>
						</div>
						<Link
							to={analyticsLink}
							className="inline-flex items-center gap-2 rounded-lg border border-border bg-background/80 px-4 py-2 text-sm font-semibold text-foreground transition-colors hover:border-primary/40 hover:bg-primary/5"
						>
							{analyticsLabel}
							<i className="ri-arrow-right-up-line text-base" aria-hidden />
						</Link>
					</div>
					{filter ? <div className="mt-5">{filter}</div> : null}
				</div>
				<div className="px-6 py-6">{children}</div>
			</div>
		</section>
	)
}
